import React, { createContext, useContext, ReactNode } from 'react';
import { User } from '../utils/firebaseUtils';
import { useFirebaseAuth } from '../utils/firebaseUtils';

interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  /* True when the last sign-in was refused because the account is waitlisted. */
  waitlisted: boolean;
  dismissWaitlist: () => void;
  dismissError: () => void;
  signIn: () => Promise<void>;
  signInWithPassword: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const auth = useFirebaseAuth();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
